import React from "react";
import { useState } from "react";
import { useReactFlow } from "reactflow";
import "reactflow/dist/style.css";
// import { Plus } from "../../../node_modules/lucide-react/dist/lucide-react";
// import { Minus } from "../../../node_modules/lucide-react/dist/lucide-react";
// import { Lock } from "../../../node_modules/lucide-react/dist/lucide-react";
// import {  } from "../../../node_modules/lucide-react/dist/lucide-react";
import { Plus, Minus, Lock, Square, LockOpen } from "lucide-react";

const CustomControl = ({
  setInteractive,
  interactive,
  showEditQuestions,
  treeType,
  showEditButton,
}) => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();
  console.log(showEditQuestions, treeType);

  const toggleInteractivity = () => {
    setInteractive((prevInteractive) => !prevInteractive);
  };
  return (
    <div
      className={`absolute left-[1rem] z-[10] flex flex-col bg-white border border-[#D9D9D9] ${
        showEditQuestions.includes(treeType) ||
        showEditButton.includes(treeType)
          ? "top-[16rem]"
          : "top-[19rem]"
      }`}
    >
      <button onClick={zoomIn} className="border-b p-1 border-[#D9D9D9]">
        <Plus size={16} />
      </button>
      <button onClick={zoomOut} className="border-b p-1 border-[#D9D9D9]">
        <Minus size={16} />
      </button>
      <button onClick={fitView} className="border-b p-1 border-[#D9D9D9]">
        <Square size={16} />
      </button>
      <button onClick={toggleInteractivity} className="p-1">
        {interactive ? <LockOpen size={16} /> : <Lock size={16} />}
      </button>
    </div>
  );
};

export default CustomControl;
